export var SearchLeadMapper = function (data) {
    var _a;
    var searchLeadMainEntity = {
        searchList: [],
    };
    if (data && ((_a = data.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        data.data.map(function (record) {
            var searchObj = {
                clientName: record.clientName,
                AcCode: record.acCode,
                pan: record.pan,
                mobileNo: record.mobileNo,
                emailId: record.emailId,
                registrationStatus: record.registrationStatus,
                ucc: record.ucc,
                isClient: record.clientType === "Partner Lead"
                    ? false
                    : record.clientType.toLowerCase() == "client"
                        ? true
                        : false,
                leadId: record.clientType === "Lead" || record.clientType === "Partner Lead"
                    ? record.acCode
                    : "",
                isClientBool: record === null || record === void 0 ? void 0 : record.isClient,
                uniqueCode: record === null || record === void 0 ? void 0 : record.uniqueCode,
            };
            searchLeadMainEntity.searchList.push(searchObj);
        });
    }
    return searchLeadMainEntity;
};
